import type { ZAFClientInstance } from '@/interfaces'

declare const ZAFClient: {
  init: () => ZAFClientInstance | null
} | undefined

export const zafClient: ZAFClientInstance | null =
  typeof ZAFClient !== 'undefined' ? ZAFClient.init() : null
